// extracted by mini-css-extract-plugin
module.exports = {"link":"detail_link__312ez","btnAddFiles":"detail_btnAddFiles__21dRn"};